__webpack_require__.p = "/acquisition-contracts-page-design/referrals-hub/";